class PillowPackageWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainFunction();
  }

  mainFunction() {
    this.getJson();
    this.getPackageProduct();
    this.getInsertVariant();
    this.quantityChange();
  }
  getJson() {
    this.jsonScript = this.querySelector('.js-package-json script[type="application/json"]');
    if (this.jsonScript) {
      this.payload = JSON.parse(this.jsonScript.textContent.trim());
    }
  }

  getPackageProduct() {
    this.packageProducts = this.querySelectorAll('variant-info');
    this.packageProductsPrice = this.querySelectorAll('.js-variant-price');
    this.quantityWrapper = this.querySelectorAll('quantity-wrapper');
  }

  getInsertVariant() {
    let insertWrapper = this.querySelector("pillow-package-insert");
    let insertInputs = insertWrapper.querySelectorAll("input");
    let productId = null;

    insertInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        let inputValue = e.currentTarget.getAttribute("value");

          let selectedKey = 'polyfill';
          if (inputValue.includes('Faux')) selectedKey = 'faux_down';
          else if (inputValue.includes('Poly')) selectedKey = 'polyfill';
          else selectedKey = 'cover';
        
        this.packageProductsPrice.forEach((product) => {
          productId = product.dataset.variantId;
          
          this.payload.package_products.forEach(pkg => {
            pkg.size_product.forEach(size => {
              let sizeId = String(size.size_product_id);
              if (sizeId === productId) {
                let matchInsertId = size.size_product_metafield_insert_prod?.insert_product_variants[selectedKey]?.id || size.size_product_metafield_insert_prod?.insert_product_variants['faux_down']?.id || null;
                let matchInsertPrice = size.size_product_metafield_insert_prod?.insert_product_variants[selectedKey]?.price || size.size_product_metafield_insert_prod?.insert_product_variants['faux_down']?.price || null;
                let insertPrice = size.size_product_metafield_insert_prod?.insert_product_variants[selectedKey]?.insert_price || size.size_product_metafield_insert_prod?.insert_product_variants['faux_down']?.insert_price || null;

                product.textContent = `$${matchInsertPrice?.toFixed(2)}`;
                product.dataset.totalPrice = matchInsertPrice;
                product.dataset.insertType = size.size_product_metafield_insert_prod?.insert_product_variants[selectedKey] ? inputValue : 'Faux Down';
                product.dataset.insertPrice = insertPrice;
                
                if(selectedKey != 'cover') {
                  product.dataset.insertId = matchInsertId;
                } else {
                  product.dataset.insertId = "";
                }
              }
            });
          });
        })
        this.totalPriceUpdate();
        this.updatePackagePriceRange();
      })
    })
  }

  quantityChange() {
    this.quantityWrapper.forEach(wrapper => {
      let minusBtn = wrapper.querySelector('.pillow-package__qty-btn.minus');
      let plusBtn  = wrapper.querySelector('.pillow-package__qty-btn.plus');
      let input    = wrapper.querySelector('.pillow-package__qty-input');

      minusBtn.addEventListener('click', () => this.onMinusClick(input));
      plusBtn.addEventListener('click', () => this.onPlusClick(input));

      // optional: update on manual typing
      // input.addEventListener('input', () => {
      //   const val = Number(input.value) || 0;
      //   input.value = val < 0 ? 0 : val;
      // });
    });
  }
    
  onPlusClick(input) {
    const current = Number(input.value) || 0;
    input.value = current + 1;
    this.totalPriceUpdate();
  }

  onMinusClick(input) {
    const current = Number(input.value) || 0;
    input.value = current > 0 ? current - 1 : 0;
    this.totalPriceUpdate();
  }

  totalPriceUpdate() {
    const totalEl = this.querySelector("[data-total]");
    let totalBtn = document.querySelector(".js-total-btn");
    if (!totalEl) return;

    let grandTotal = 0;
    let totalQty = 0;

    this.packageProducts.forEach(wrapper => {
      // let insertPrice = 0;
      if (!wrapper) return;

      const priceEl = wrapper.querySelector(".js-variant-price");
      const qtyEl = wrapper.querySelector(".pillow-package__qty-input");
      if (!priceEl || !qtyEl) return;

      const qty = Number(qtyEl.value) || 0;

      // if(qty != 0) {
      //   insertPrice = Number(priceEl.dataset.insertPrice) || 0;
      // }
      const totalPrice = Number(priceEl.dataset.totalPrice) || 0;

      // const coverPrice = totalPrice - insertPrice;

      // const corrected = (coverPrice * qty) + insertPrice;

      grandTotal += (totalPrice * qty);
      totalQty += qty;
    });

    totalEl.textContent = `$${grandTotal.toFixed(2)}`;
    totalBtn.textContent = `$${grandTotal.toFixed(2)}`;
    this.getCartData();
    this.submitBtnToggle(totalQty);
  }


  getCartData() {
    const cartLines = [];

    (this.packageProducts || []).forEach(productEl => {
      let prodPrice = productEl.querySelector(".js-variant-price");
      let sizeVariantId = prodPrice?.dataset.variantId;
      let qty = Number(productEl.querySelector("input.pillow-package__qty-input").value) || 0;
      
      if (qty <= 0) return;

      let sizeLabel = prodPrice?.dataset.variantSize;
      let insertVariantType = prodPrice?.dataset.insertType; 
      let insertIdRaw = prodPrice?.dataset.insertId;
      let insertVariantId = insertIdRaw ? insertIdRaw : null;

      cartLines.push({
        id: sizeVariantId,
        quantity: Number(qty),
        properties: {
          "_Insert Size": String(sizeLabel || ''),
          "_Insert Type": String(insertVariantType || ''),
          _package_bundle: `bundle-${Date.now()}-${Math.floor(Math.random() * 100000)}`
        }
      });

      if (insertVariantId) {
        cartLines.push({
          id: insertVariantId,
          quantity: Number(qty),
          properties: {
            _package_bundle: `bundle-${Date.now()}-${Math.floor(Math.random() * 100000)}`
          }
        });
      }
    });

    return cartLines;
  }

  updatePackagePriceRange() {
    const priceEls = this.packageProductsPrice?.length ? Array.from(this.packageProductsPrice) : Array.from(this.querySelectorAll('.js-variant-price'));
    const prices = priceEls.map(el => {
      const ds = el.dataset?.totalPrice;
      if (ds !== undefined && ds !== null && ds !== '') {
        const n = Number(ds);
        return Number.isFinite(n) ? n : null;
      }
      const raw = (el.textContent || '').replace(/[^\d.]/g, '');
      const n2 = parseFloat(raw);
      return Number.isFinite(n2) ? n2 : null;
    }).filter(v => v !== null);

    const priceEl = document.querySelector('.js-package-price');
    if (!priceEl) return;

    if (prices.length === 0) {
      priceEl.textContent = '$0.00';
      return;
    }

    const min = Math.min(...prices);
    const max = Math.max(...prices);

    const fmt = (val) => {
      return `$${Number(val).toFixed(2)}`;
    };

    priceEl.textContent = (min === max) ? fmt(min) : `${fmt(min)} - ${fmt(max)}`;

    priceEl.dataset.minPrice = String(min);
    priceEl.dataset.maxPrice = String(max);
  }

  submitBtnToggle(qty) {
    let submitBtn = document.querySelector(".js-package-submit-btn");
    let insertSelected = document.querySelector(".js-package-insert:checked") !== null;
    let atcBtnText = document.querySelector(".js-package-atc-btn-text");
    let noSelectText = atcBtnText.dataset.noSelectText;
    let atcText = atcBtnText.dataset.atcText;

    if (insertSelected && qty >= 2) {
      submitBtn.removeAttribute("disabled");
      atcBtnText.textContent = atcText;
    } else {
      submitBtn.setAttribute("disabled", true);
      atcBtnText.textContent = noSelectText;
    }
  }
}
customElements.define('pillow-package-wrapper', PillowPackageWrapper);